require('./timepicker.css');
module.exports = require('./index-nocss.js');
